import { IApiError } from '@/models/apiError.model';
import { IBanner } from '@/models/banners.model';
import { IPagination } from '@/models/pagination.model';
import { TGetBannersQuery } from '../helpers';

export const BANNERS_SLICE_NAME = 'bannersList';

export interface BannersState {
  bannersList: {
    data: IBanner[];
    meta: IPagination;
  } | null;
  banner: IBanner | null;
  isLoadingBanner: boolean;
  isLoading: boolean;
  query: TGetBannersQuery | null;
  error: IApiError | null;
}

export const initialState: BannersState = {
  bannersList: null,
  banner: null,
  isLoadingBanner: false,
  isLoading: false,
  query: null,
  error: null,
};
